import _, { parseInt } from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import ValidateKeyGql from '@/extensions/marketing/store/graphql/queries/ValidateCampaignKey.gql';
import CampaignsGql from '@/extensions/marketing/store/graphql/queries/Campaigns.gql';
import CampaignGql from '@/extensions/marketing/store/graphql/queries/Campaign.gql';
import CampaignsPaginatedGql from '@/extensions/marketing/store/graphql/queries/CampaignsPaginated.gql';
import CreateCampaignGql from '@/extensions/marketing/store/graphql/mutations/CreateCampaign.gql';
import UpdateCampaignGql from '@/extensions/marketing/store/graphql/mutations/UpdateCampaign.gql';
import DeleteCampaignGql from '@/extensions/marketing/store/graphql/mutations/DeleteCampaign.gql';

export default {
    validateKey: (key, cmsID = null, excludedCampaignID = null) =>
        new Promise((resolve, reject) => {
            let variables = { key };
            if (cmsID) variables.cms = parseInt(cmsID);
            if (excludedCampaignID) variables.excludedCampaign = parseInt(excludedCampaignID);

            apolloClient
                .query({
                    query: ValidateKeyGql,
                    variables
                    // fetchPolicy: 'no-cache'
                })
                .then(({ data }) => resolve(data.EX_MARKETING_ValidateCampaignKey))
                .catch(err => reject(err));
        }),
    fetchList: (cmsID = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (cmsID) variables.cms = parseInt(cmsID);

            apolloClient
                .query({
                    query: CampaignsGql,
                    variables
                })
                .then(({ data }) => resolve(data.EX_MARKETING_Campaigns))
                .catch(err => reject(err));
        }),
    fetchCampaignsPaginated: data =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: CampaignsPaginatedGql,
                    variables: {
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        link: _.get(data, 'link.route', '/marketing/campaign/'),
                        filters
                    }
                })
                .then(({ data }) => resolve(data.EX_MARKETING_CampaignsPaginated))
                .catch(err => reject(err));
        }),
    fetchCampaign: (id, cmsID = null) => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CampaignGql,
                    variables: { id: parseInt(id), cms: parseInt(cmsID) }
                })
                .then(({ data }) => resolve(data.EX_MARKETING_Campaign))
                .catch(err => reject(err));
        });
    },
    create: campaign => {
        if (campaign === undefined) throw new Error('required argument is missing');

        campaign = _.removeDeepByKey(campaign, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateCampaignGql,
                    variables: { campaign }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_MARKETING_CreateCampaign);
                })
                .catch(err => reject(err));
        });
    },
    update: campaign => {
        if (campaign === undefined) throw new Error('required argument is missing');

        campaign = _.removeDeepByKey(campaign, '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateCampaignGql,
                    variables: { campaign }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_MARKETING_UpdateCampaign);
                })
                .catch(err => reject(err));
        });
    },
    delete: id => {
        if (id === undefined) throw new Error('required argument is missing');

        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteCampaignGql,
                    variables: { id: parseInt(id) }
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.EX_MARKETING_DeleteCampaign);
                })
                .catch(err => reject(err));
        });
    }
};
